import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Modal from "react-bootstrap/Modal";
import Select from 'react-select'
import IntlTelInput from 'react-intl-tel-input';
import 'libphonenumber-js-utils/dist/libphonenumber.js';
import { toast } from 'react-toastify';
import {editAgent} from "../../actions/actions";
import {connect} from "react-redux";
import Swal from 'sweetalert2';

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AgentEdit extends Component {

    constructor(props) {

        super(props);

        this.currentUser=this.props.chatprop.allAgents.find(agent=>agent.id==this.props.chatprop.modal.data.id);
        this.state = {
            phoneInvalid: true,
            phoneValue: "",
            phoneNumber:"",
            email:this.currentUser.email,
            emailInvalid: false,
            nameSurnameInvalid: false,
            passwordInvalid: false,
            nameSurname: this.currentUser.username,
            password: "",
            selectedRole:this.currentUser.role,
            selectedDepartment:[],
            defaultOptions:[]

        };
        this.addAgentEvent=this.addAgentEvent.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeNameSurname = this.onChangeNameSurname.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.setRoleValue = this.setRoleValue.bind(this);
        this.setDepartmentValue = this.setDepartmentValue.bind(this);






    }
    componentWillMount() {
        const defaultOptions=[];
        this.props.chatprop.allDepartments.filter(dep=>dep.state==1).map(depkey=>(

            Object.keys(this.currentUser.departments).map(depkey2 => (
                depkey2==depkey.id ?
                    defaultOptions.push({
                        value:depkey.id,
                        label:depkey.name
                    })
                    : {}

            ))
        ));

        this.setState({
            defaultOptions:defaultOptions
        });
        this.setState({
            selectedDepartment : defaultOptions,
        });
    }



    setRoleValue = selectedOption => {
        this.setState({
            selectedRole : selectedOption.value,
        });

    };
    setDepartmentValue = selectedOption => {
        this.setState({
            selectedDepartment : selectedOption,
        });


    };


    onChangePassword(e){
        this.setState({
            password : e.target.value.trim(),
        });

        if(this.state.password.trim().length<8){
            this.setState({
                passwordInvalid :true,
            });
        } else{
            this.setState({
                passwordInvalid :false,
            });
        }
    }
    onChangeNameSurname(e) {
        if(this.nameSurnameValidation(e.target.value)){
            this.setState({
                nameSurname : e.target.value,
                nameSurnameInvalid:false
            });
        } else{
            this.setState({
                nameSurnameInvalid : true
            });

        }

    }
    onChangeEmail(e) {
        if(this.emailValidation(e.target.value)){
            this.setState({
                email : e.target.value,
                emailInvalid:false
            });
        } else{
            this.setState({
                emailInvalid : true
            });

        }

    }

    addAgentEvent(e){
        if(!this.nameSurnameValidation(this.state.nameSurname)){
            toast.error("Check the correctness of name and surname");
            return false;
        }
        if(this.state.phoneValue.trim().length>0){
            if(!this.state.phoneInvalid){
                toast.error("Check phone number");
                return false;
            }
        }
        if(this.state.email.trim().length<1 || !this.emailValidation(this.state.email.trim())){
            toast.error("Check your e-mail address");
            return false;
        }



        var $updateData={
            email:this.state.email,
            id:this.currentUser.id,
            namesurname:this.state.nameSurname,
            department:this.state.selectedDepartment,
        };

        if(this.state.password.length>0){
            if(this.state.password.trim().length<8){
                toast.error("Password must be a minimum of 8 characters");
                return false;
            }
            $updateData.password=this.state.password;
        }
        if(this.currentUser.role != 1){
            $updateData.role=this.state.selectedRole;
        }
        if(this.state.phoneValue.trim().length>0){
            $updateData.phoneNumber=this.state.phoneNumber.trim();
        }
        Swal.fire({
            title: 'Are you sure you want to update the agent ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(editAgent($updateData));
            }
        });



    }
    emailValidation(email){
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!email || regex.test(email) === false){
            return false;
        }
        return true;
    }

    nameSurnameValidation(name){
        const regex=/[a-zA-Z-ğüşöçıİĞÜŞÖÇ]+ [a-zA-Z-ğüşöçıİĞÜŞÖÇ]+$/;
        if(!name || regex.test(name) === false){
            return false;
        }
        return true;
    }

    render() {
        const { t } = this.props

            const roleOptions=[
                { value: '2', label: 'Administrator' },
                { value: '3', label: 'Agent' }
            ];





        return (

            <>

                <Modal.Header closeButton>
                    <Modal.Title>Edit Agent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form method="post" className="validate-form addAgent" encType="multipart/form-data">
                        <div className="form-group">
                            <label htmlFor="region-name">Name surname</label>
                            <div className="position-relative">
                                <input type="text"
                                       className="form-control form-control-lg"
                                       defaultValue={this.state.nameSurname}
                                       onChange={this.onChangeNameSurname.bind(this)}
                                       placeholder="Name surname" />
                                {this.state.nameSurnameInvalid === true &&
                                <div style={{ color:"red",marginTop: "5px"}}>İnvalid Name Surname</div>
                                }
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="region-name">Phone number</label>
                            <div className="position-relative">
                                <IntlTelInput
                                    containerClassName="intl-tel-input"
                                    inputClassName="form-control"
                                    preferredCountries={['tr']}
                                    type="tel"
                                    utilsScript={"libphonenumber.js"}
                                    onPhoneNumberChange={(status, value, countryData, number, id) => {
                                        if(value.trim().length>0){
                                            this.setState({
                                                "phoneInvalid":status
                                            });
                                        }else{
                                            this.setState({
                                                "phoneInvalid":true
                                            });
                                        }
                                        this.setState({
                                            "phoneValue":value
                                        });
                                        this.setState({
                                            "phoneNumber":number
                                        });
                                    }}

                                />
                                {this.state.phoneInvalid === false &&
                                <div style={{ color:"red",marginTop: "5px"}}>İnvalid Phone</div>
                                }
                                <div>{this.currentUser.phone_number}</div>


                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="region-name">Email</label>
                            <div className="position-relative">
                                <input type="email"
                                       className="form-control form-control-lg "
                                       defaultValue={this.state.email}
                                       name="email" placeholder="Email"
                                       onChange={this.onChangeEmail.bind(this)}
                                />
                                {this.state.emailInvalid === true &&
                                <div style={{ color:"red",marginTop: "5px"}}>İnvalid Email</div>
                                }
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="region-name">Password</label>
                            <div className="position-relative">
                                <input type="password" id="password"
                                       className="form-control form-control-lg "
                                       name="password"
                                       onChange={this.onChangePassword.bind(this)}
                                       placeholder="******" />
                                {this.state.passwordInvalid === true &&
                                <div style={{ color:"red",marginTop: "5px"}}>password must be a minimum of 8 characters</div>
                                }
                            </div>
                        </div>
                        {this.currentUser.role != 1 &&
                        <div className="form-group">
                            <label htmlFor="region-name">Role</label>
                            <div className="position-relative">

                                <Select
                                    defaultValue={
                                        roleOptions.filter(option =>
                                            option.value == this.currentUser.role)
                                    }
                                    options={roleOptions}
                                    closeMenuOnSelect={false}
                                    placeholder="choose role"
                                    onChange={this.setRoleValue}
                                    noOptionsMessage={() => "role not found"}

                                />

                            </div>
                        </div>
                        }

                        <div className="form-group">
                            <label htmlFor="region-name">Select Department</label>
                            <div className="position-relative">

                                <Select
                                    defaultValue={this.state.defaultOptions}
                                    options={this.props.chatprop.allDepartments.map(depkey=>({
                                        value:depkey.id,
                                        label:depkey.name
                                    }))}
                                    closeMenuOnSelect={false}
                                    isMulti
                                    placeholder="Select Department"
                                    noOptionsMessage={() => "Department Not Found"}
                                    onChange={this.setDepartmentValue}
                                />
                            </div>

                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="chat-button chat-button-success ml-1 "
                            onClick={this.addAgentEvent.bind(this)}
                    >
                        <span >Update, Save</span>
                    </button>
                </Modal.Footer>
            </>

        );
    }
}

export default withTranslation()(AgentEdit);
